import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { sprintf } from 'sprintf-js';

@Injectable()
export class EventInvitationService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/invitations`);
  }

  getStarInvitations(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/invitations/all`, urlParams);
    return this.http.get<any>(url, {
      params: this.toHttpParams(apiParams),
    });
  }
}
